'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _StaticControl = require('../../../lib/ui/StaticControl');

var _StaticControl2 = _interopRequireDefault(_StaticControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var About = function About(element) {
  _classCallCheck(this, About);

  var displayBoolean = function displayBoolean(value) {
    if (typeof value === 'undefined') {
      return 'Nee';
    }

    return value ? 'Ja' : 'Nee';
  };
  var portrait = typeof window.orientation !== 'undefined' && window.orientation !== -90 && window.orientation !== 90;

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Over PRIM',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }],
    contextMenu: [{
      onclick: function onclick() {
        location.reload(true);
      },
      icon: '\uE0DA',
      label: 'Applicatie herstarten'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var fieldsetApplication = document.createElement('fieldset');
  var legendApplication = document.createElement('legend');
  legendApplication.innerHTML = 'Applicatie';
  fieldsetApplication.appendChild(legendApplication);

  new _StaticControl2.default(fieldsetApplication, { label: 'PRIM versie nummer', value: window.PRIM.version });
  new _StaticControl2.default(fieldsetApplication, { label: 'PRIM versie tijdstip', value: window.PRIM.buildTimestamp });
  new _StaticControl2.default(fieldsetApplication, { label: 'PRIM is gecached', value: displayBoolean(applicationCache && applicationCache.status !== applicationCache.UNCACHED) });

  var fieldsetLicense = document.createElement('fieldset');
  var legendLicense = document.createElement('legend');
  legendLicense.innerHTML = 'Abonnement';
  fieldsetLicense.appendChild(legendLicense);

  if (window.PRIM.License) {
    if (window.PRIM.License.isDemo) {
      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Demonstratieversie, er zullen geen gegevens worden bewaard' });
    } else if (window.PRIM.License.validThru) {
      if (window.PRIM.License.valid) {
        new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt t/m ' + new Date(window.PRIM.License.validThru) });
      } else {
        new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Is verlopen op ' + new Date(window.PRIM.License.validThru) + ', beperkingen actief' });
      }
    } else if (window.PRIM.License.valid) {
      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt onbeperkt' });
    } else {
      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' });
    }
  } else {
    new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' });
  }

  var fieldsetSpecifications = document.createElement('fieldset');
  var legendSpecifications = document.createElement('legend');
  legendSpecifications.innerHTML = 'Specificaties';
  fieldsetSpecifications.appendChild(legendSpecifications);

  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser agent', value: navigator.userAgent });
  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser platform', value: navigator.platform });
  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser taal', value: navigator.language });
  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser is online', value: displayBoolean(navigator.onLine) });
  new _StaticControl2.default(fieldsetSpecifications, { label: 'Scherm ruimte', value: screen.availWidth + '×' + screen.availHeight + '×' + screen.pixelDepth });
  new _StaticControl2.default(fieldsetSpecifications, { label: 'Scherm orientatie', value: typeof window.orientation !== 'undefined' ? portrait ? 'Portrait' : 'Landscape' : 'Onbekend' });

  div.appendChild(fieldsetApplication);
  div.appendChild(fieldsetLicense);
  div.appendChild(fieldsetSpecifications);

  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = About;


//////////////////
// WEBPACK FOOTER
// ./js/modules/about/action/About.js
// module id = 16
// module chunks = 0